import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { literals } from "@/constants/literals";
import { BASE_URL } from "@/constants/constants";
import useReceptionDataStore from "@/store/useReceptionData.store";
import ReceptionOrderHeader from "../components/ReceptionOrderHeader";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import RadioGroup from "@/pages/capture/components/RadioGroup";

const ReceptionPackagingEdition = () => {
  const { receptionData, updateReceptionData } = useReceptionDataStore();
  const navigate = useNavigate();

  const [ownPackaging, setOwnPackaging] = useState(
    receptionData.ownPackaging || false,
  );
  const [correctPackaging, setCorrectPackaging] = useState(
    receptionData.correctPackaging || false,
  );
  const [damagedPackaging, setDamagedPackaging] = useState(
    receptionData.damagedPackaging || false,
  );

  const goToReceptionResume = () =>
    navigate(`${BASE_URL}/capture/reception/resume`);

  const updatePackageInformation = () => {
    const newRepectionData = {
      ...receptionData,
      ownPackaging: ownPackaging,
      correctPackaging: correctPackaging,
      damagedPackaging: damagedPackaging,
    };
    if (!ownPackaging && receptionData.packagingReference) {
      delete newRepectionData.packagingReference;
    }
    if (ownPackaging && receptionData.customer && receptionData.orderNumber) {
      newRepectionData.packagingReference = `${receptionData.customer}_${receptionData.orderNumber}`;
    }
    updateReceptionData(newRepectionData);
    goToReceptionResume();
  };

  const noDataChange = useMemo(
    () =>
      receptionData.correctPackaging == correctPackaging &&
      receptionData.ownPackaging == ownPackaging &&
      receptionData.damagedPackaging === damagedPackaging,
    [ownPackaging, correctPackaging, damagedPackaging, receptionData],
  );

  const changeOwnPackaging = () => {
    setOwnPackaging((previousValue) => {
      if (!previousValue) return true;
      return !previousValue;
    });
  };
  const changeCorrectPackaging = () => {
    setCorrectPackaging((previousValue) => {
      if (!previousValue) return true;
      return !previousValue;
    });
  };
  const changeDamagedPackaging = () => {
    setDamagedPackaging((previousValue) => {
      if (!previousValue) return true;
      return !previousValue;
    });
  };

  return (
    <div className="min-h-fulldpx flex flex-col justify-between bg-ib-pt-color-white">
      <ReceptionOrderHeader />
      <form
        onSubmit={updatePackageInformation}
        className="flex flex-col flex-1 justify-between md:justify-start"
      >
        <div className="w-full px-4 pt-4 md:flex md:flex-col items-center">
          <div className="mb-6 md:mb-1">
            <RadioGroup
              label={literals.ownPackaging}
              selected={ownPackaging}
              onChange={changeOwnPackaging}
            />
          </div>
          <div className="mb-6 md:mb-1">
            <RadioGroup
              label={literals.correctPackaging}
              selected={correctPackaging}
              onChange={changeCorrectPackaging}
            />
          </div>
          <div className="mb-6 md:mb-4">
            <RadioGroup
              label={literals.damagedPackaging}
              selected={damagedPackaging}
              onChange={changeDamagedPackaging}
            />
          </div>
        </div>
        <div className="p-4 md:px-0 flex flex-col md:flex-row gap-4 border-t border-ib-pt-color-gray-300 md:mx-14 lg:mx-[calc((100%-797px)/2)] md:justify-center">
          <div className="md:capture-button">
            <PrimaryButton
              size="medium"
              label={literals.saveChanges}
              colour="red"
              type="submit"
              onClick={updatePackageInformation}
              disabled={noDataChange}
            />
          </div>
          <div className="md:capture-button">
            <SecondaryButton
              size="medium"
              label={literals.cancel}
              colour="red"
              onClick={goToReceptionResume}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ReceptionPackagingEdition;
